import {ReactComponent as CloseIcon} from "../../../core/ui/icon/Close.svg";
import {ReactComponent as ArrowLeftIcon} from "../../../core/ui/icon/ArrowLeft.svg";
import {ReactComponent as TinymanLogo} from "../../../core/ui/images/Tinyman.svg";

import {Fragment} from "react";
import classNames from "classnames";

import Typography from "../../../component/typography/Typography";
import AccountAddress from "../../../wallet/account/address/AccountAddress";
import {
  getIsParentSigner,
  useSelectedAccountAddress,
  useWalletContext
} from "../../../wallet/util/context/WalletContext.utils";
import useDisconnectAccount from "../../../wallet/account/useDisconnectAccount";
import Button from "../../../component/button/Button";
import {
  useSwapFlowDispatch,
  useSwapFlowState
} from "../../../swap/flow/context/SwapFlowContext";
import {SwapFlowView} from "../../../swap/flow/context/SwapFlowContext.types";
import {getThemeVarsFromUrl} from "../../util/theme/themeUtils";
import IconButton from "../../../component/button/icon/IconButton";

import "./_header.scss";

function Header() {
  const selectedAccountAddress = useSelectedAccountAddress();
  const disconnectWallet = useDisconnectAccount();
  const themeVars = getThemeVarsFromUrl();
  const {view} = useSwapFlowState();
  const dispatchSwapFlowAction = useSwapFlowDispatch();
  const {walletType} = useWalletContext();
  const isParentSigner = getIsParentSigner(walletType);

  return (
    <header className={"is-vertically-centered has-space-between header"}>
      {renderInfo()}

      {selectedAccountAddress &&
        (isParentSigner ? (
          <AccountAddress
            customClassName={"header__account-address"}
            address={selectedAccountAddress}
          />
        ) : (
          <Button
            aria-label={"Disconnect wallet"}
            customClassName={classNames(
              "is-vertically-centered",
              "header-button",
              "header__account-address-button"
            )}
            typography={"body"}
            onClick={disconnectWallet}
            size={"small"}>
            <div
              className={
                "is-vertically-centered header__account-address-button__disconnect"
              }>
              <Typography>{"Disconnect"}</Typography>

              <CloseIcon className={"header__disconnect-icon"} />
            </div>

            <AccountAddress address={selectedAccountAddress} />
          </Button>
        ))}
    </header>
  );

  function renderInfo() {
    let content = <Fragment />;

    if (view === SwapFlowView.Sign) {
      content = (
        <IconButton
          aria-label={"Go back to swap form"}
          customClassName={"header-button"}
          onClick={goBackToFormView}>
          <ArrowLeftIcon />
        </IconButton>
      );
    } else if (themeVars?.shouldDisplayTinymanLogo) {
      content = <TinymanLogo aria-label={"Tinyman logo"} />;
    } else {
      content = (
        <div className={"is-flex-column header__title-and-branding"}>
          <Typography
            customClassName={"text-left-aligned"}
            fontWeight={"bold"}
            as={"h1"}
            variant={"body"}>
            {themeVars?.title || "Swap"}
          </Typography>

          <Typography as={"span"} variant={"tiny"}>
            {"Powered by Tinyman Protocol"}
          </Typography>
        </div>
      );
    }

    return content;
  }

  function goBackToFormView() {
    dispatchSwapFlowAction({type: "SET_VIEW", view: SwapFlowView.Form});
  }
}

export default Header;
